import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router"

const routes: RouteRecordRaw[] = [
  // Base Layout
  {
    path: "/",
    name: "BaseLayout",
    component: () => import("src/layouts/BaseLayout.vue"),
    children: [
      // Auth Layout
      {
        path: "auth",
        name: "AuthLayout",
        component: () => import("src/layouts/AuthLayout.vue"),
        children: [
          {
            path: "admin/login",
            name: "Login",
            component: () => import("src/views/Auth/LoginPage.vue"),
            meta: {
              layout: "AuthLayout",
            },
          },
        ],
      },

      // Main Layout
      {
        path: "/",
        name: "MainLayout",
        component: () => import("src/layouts/MainLayout.vue"),
        children: [
          // Dashboard
          {
            path: "/",
            name: "Home",
            component: () => import("src/views/Dashboard.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Merchants
          {
            path: "/admin/merchants",
            name: "Merchants",
            component: () => import("src/views/Merchants/MerchantsList.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Products
          {
            path: "/admin/products",
            name: "Products",
            component: () => import("src/views/Products/ListProducts.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Checkouts
          {
            path: "/admin/checkouts",
            name: "ListCheckouts",
            component: () => import("src/views/Checkouts/ListCheckouts.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Orders
          {
            path: "/admin/orders",
            name: "Orders",
            component: () => import("src/views/Orders/ListOrders.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          {
            path: "/admin/orders/:orderId",
            name: "OrderDetail",
            component: () => import("src/views/Orders/OrderView.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Features Control
          {
            path: "/admin/:merchantId/feature-controls",
            name: "FeaturesControl",
            component: () =>
              import("src/views/FeaturesControl/ListFeaturesControl.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Access Tabs
          {
            path: "/admin/:merchantId/access-tabs",
            name: "AccessTabs",
            component: () => import("src/views/AccessTabs/ListAccessTabs.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Merchants Profile
          {
            path: "/admin/merchants/profiles",
            name: "MerchantsProfiles",
            component: () =>
              import("src/views/MerchantsProfile/ListMerchantsProfiles.vue"),
            meta: {
              layout: "MainLayout",
            },
          },
          {
            path: "/admin/merchants/:merchantId/profiles",
            name: "MerchantProfileDetail",
            component: () =>
              import("src/views/MerchantsProfile/ViewMerchantsProfile.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Subscriptions
          {
            path: "/admin/subscriptions",
            name: "Subscriptions",
            component: () =>
              import("src/views/Subscriptions/ListSubscriptions.vue"),
            meta: {
              layout: "MainLayout",
            },
          },

          // Payment Requests
          {
            path: "/admin/payment-requests",
            name: "PaymentRequests",
            component: () =>
              import("src/views/PaymentRequests/ListPaymentRequests.vue"),
            meta: {
              layout: "MainLayout",
            },
          },
        ],
      },
    ],
  },

  // 404
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: () => import("src/views/404.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { left: 0, top: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  const access_token = localStorage.getItem("auth.AccessToken")

  const AuthLayout = to.meta.layout === "AuthLayout"

  const isAuthenticated = access_token !== null

  if (!isAuthenticated && !AuthLayout) {
    return next({ name: "Login" })
  }

  if (isAuthenticated && AuthLayout) {
    return next({ name: "Home" })
  }

  next()
})

export default router
